import React from 'react';
import { Box, Typography } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

// Bossard Blue color for section titles
const BOSSARD_BLUE = '#007ac3';

export const SectionHeader: React.FC<{
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  disabled?: boolean;
}> = ({ title, isOpen, onToggle, disabled = false }) => (
  <Box 
    component="button"
    onClick={disabled ? undefined : onToggle}
    sx={{ 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      my: 2,
      width: '100%',
      background: 'transparent',
      border: 'none',
      padding: 0,
      cursor: disabled ? 'default' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      pointerEvents: disabled ? 'none' : 'auto',
      '&:hover': {
        background: 'transparent',
      },
      '&:active, &:focus': {
        outline: 'none',
        background: 'transparent',
      }
    }}
  >
    <Typography 
      sx={{ 
        fontFamily: '"Dinot Black", Arial, sans-serif',
        fontWeight: 900,
        fontSize: '1.25rem',
        color: (theme) => theme.palette.mode === 'light' ? BOSSARD_BLUE : '#ffffff',
        textTransform: 'none',
        letterSpacing: '0.5px'
      }}
    >
      {title}
    </Typography>
    {isOpen ? (
      <ExpandLess sx={{ color: (theme) => theme.palette.mode === 'light' ? BOSSARD_BLUE : '#ffffff' }} />
    ) : (
      <ExpandMore sx={{ color: (theme) => theme.palette.mode === 'light' ? BOSSARD_BLUE : '#ffffff' }} />
    )}
  </Box>
);
